import { useEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router";

export function AuthLayout() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return (
    <div className="flex min-h-dvh flex-col overflow-x-clip">
      <main className="flex flex-1 flex-col">
        <header
          className="sticky top-0 z-30 flex shrink-0 items-center border-b border-border bg-background px-4"
          style={{
            height: "calc(48px + var(--safe-area-inset-top))",
            paddingTop: "var(--safe-area-inset-top)",
          }}
        >
          <span className="text-base font-semibold text-foreground">
            Sample Mobile
          </span>
        </header>
        <Outlet />
      </main>
    </div>
  );
}
